import { Component, OnInit, ViewChild, ViewContainerRef, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap';
import { BlockUiService } from '../services/blockui.service';
import { NomenclatureService } from '../services/nomenclature.service';
import { ExternalCaseService } from '../services/external-case.service';
import { CaseService } from '../services/case.service';
import { ExternalCase, ExternalCaseSearch } from '../beans/external-case';
import { Lawyer } from '../beans/Lawyer';
import { StorageService } from '../services/storage.service';

@Component({
	selector: 'app-external-cases',
	templateUrl: './external-cases.component.html',
	styleUrls: ['./external-cases.component.scss']
})
export class ExternalCasesComponent implements OnInit {

	@ViewChild('editModal') editModal: ModalDirective;

	searchModel = new ExternalCaseSearch();
	caseList: any[] = [];
	lawyers: Lawyer[] = [];

	page = {
		number: 0,
		size: 15,
		totalElements: 0,
		totalPages: 0
	};

	cols = [
		{ title: 'Номер', name: 'number' },
		{ title: 'Насрочено на', name: 'scheduledDateFormatted' },
		{ title: 'Час', name: 'scheduledTimeFormatted' },
		{ title: 'Адвокат', name: 'lawyerName' },
		{ title: 'Бележка', name: 'noteShort' },
		{ title: 'Създадено от', name: 'createdBy' },
		{ title: 'Създадено на', name: 'createdDateFormatted' }
	];

	// edit modal
	editCase: ExternalCase = new ExternalCase();
	editMode = false;
	editScheduledDate: Date = null;
	editScheduledTime: string = null;
	editLawyerId: number = null;

	currentUserColor = '#FFFFFF';

	constructor(
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private datePipe: DatePipe,
		private nomenclatureService: NomenclatureService,
		private externalCaseService: ExternalCaseService,
		private caseService: CaseService,
		private storageService: StorageService
	) { }

	ngOnInit() {
		this.currentUserColor = this.storageService.getLoginResponse().color || '#FFFFFF';
		this.loadLawyers();
		this.search();
	}

	private loadLawyers() {
		this.nomenclatureService.getLawyers().subscribe(users => {
			this.nomenclatureService.getNdoOtgovornici().subscribe(ndo => {
				const merged = [...users];
				for (const n of ndo) {
					if (!merged.find(u => u.id === n.id)) {
						merged.push(n);
					}
				}
				merged.sort((a, b) => (a.names || '').localeCompare(b.names || ''));
				this.lawyers = merged;
			});
		});
	}

	search(page: number = 0, size: number = this.page.size, showBlockUi: boolean = true) {
		if (showBlockUi) {
			this.blockUi.start(this.vcRef);
		}

		const lawyerId = this.searchModel.lawyerId ? Number(this.searchModel.lawyerId) : null;
		const searchObj = {
			number: this.searchModel.number || null,
			lawyerId: lawyerId,
			dateFrom: this.caseService.toBackendIsoDate(this.searchModel.dateFrom),
			dateTo: this.caseService.toBackendIsoDate(this.searchModel.dateTo),
			noteText: this.searchModel.noteText || null,
			myOnly: lawyerId ? false : this.searchModel.myOnly
		};

		this.externalCaseService.search(searchObj, page, size).subscribe(
			result => {
				this.caseList = result.content.map(ec => ({
					...ec,
					scheduledDateFormatted: ec.scheduledDate
						? this.datePipe.transform(this.caseService.fromBackendDate(ec.scheduledDate), 'dd.MM.yyyy')
						: '',
					createdDateFormatted: ec.createdDate
						? this.datePipe.transform(new Date(ec.createdDate), 'dd.MM.yyyy HH:mm')
						: '',
					scheduledTimeFormatted: ec.scheduledTime ? ec.scheduledTime.substring(0, 5) : '',
				lawyerName: ec.lawyer ? ec.lawyer.names : '',
					noteShort: ec.note ? (ec.note.length > 80 ? ec.note.substring(0, 80) + '...' : ec.note) : '',
					color: (ec.lawyer && ec.lawyer.color) ? ec.lawyer.color : this.currentUserColor
				}));
				this.page = {
					number: result.number,
					size: result.size,
					totalElements: result.totalElements,
					totalPages: result.totalPages
				};
				if (showBlockUi) {
					this.blockUi.stop();
				}
			},
			() => { this.blockUi.stop(); }
		);
	}

	clearSearch() {
		this.searchModel = new ExternalCaseSearch();
	}

	onPageChange(page: number, size: number) {
		this.search(page, size, false);
	}

	// --- Modal ---

	openAdd(prefilledDate?: Date) {
		this.editCase = new ExternalCase();
		this.editMode = false;
		this.editScheduledDate = prefilledDate || null;
		this.editScheduledTime = null;
		this.editLawyerId = null;
		this.editModal.show();
	}

	openEdit(row: any) {
		this.externalCaseService.getById(row.id).subscribe(ec => {
			this.editCase = ec;
			this.editMode = true;
			this.editScheduledDate = ec.scheduledDate ? this.caseService.fromBackendDate(ec.scheduledDate) : null;
			this.editScheduledTime = ec.scheduledTime || null;
			this.editLawyerId = ec.lawyer ? ec.lawyer.id : null;
			this.editModal.show();
		});
	}

	saveCase() {
		const dto: any = {
			id: this.editCase.id || null,
			version: this.editCase.version != null ? this.editCase.version : null,
			number: this.editCase.number,
			scheduledDate: this.caseService.toBackendIsoDate(this.editScheduledDate),
			scheduledTime: this.editScheduledTime || null,
			lawyer: this.editLawyerId ? { id: Number(this.editLawyerId) } : null,
			note: this.editCase.note
		};

		const obs = this.editMode
			? this.externalCaseService.update(dto)
			: this.externalCaseService.add(dto);

		this.blockUi.start(this.vcRef);
		obs.subscribe(
			(result) => {
				console.log('>>> saveCase SUCCESS', result);
				this.editModal.hide();
				this.blockUi.stop();
				this.search(this.page.number, this.page.size);
			},
			(err) => {
				console.log('>>> saveCase ERROR', err);
				this.blockUi.stop();
				alert('Грешка при запис: ' + ((err.error && err.error.message) || err.message || 'Неизвестна грешка'));
			}
		);
	}

	canEditOrDelete(): boolean {
		if (!this.editCase || !this.editMode) return true;
		const login = this.storageService.getLoginResponse();
		if (login.authority === 'ROLE_ADMIN') return true;
		return this.editCase.lawyer && this.editCase.lawyer.id === login.id;
	}

	deleteCase() {
		if (!confirm('Сигурни ли сте, че искате да изтриете това външно дело?')) {
			return;
		}
		this.blockUi.start(this.vcRef);
		this.externalCaseService.delete(this.editCase.id).subscribe(
			() => {
				this.editModal.hide();
				this.search(this.page.number, this.page.size);
			},
			(err) => {
				this.blockUi.stop();
				alert('Грешка при триене: ' + ((err.error && err.error.message) || err.message || 'Неизвестна грешка'));
			}
		);
	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.search();
		}
		if (event.ctrlKey && event.key === 'Backspace') {
			event.preventDefault();
			this.clearSearch();
		}
	}

}
